<template>
  <Modal @close="$emit('close')">
    <div slot="body" class="body">
      <div class="row">
        <div class="col-md-6">
          <pdf src="/BeeReaders - Manual General de Usuario - 2020.pdf"></pdf>
          <pdf
            src="/BeeReaders - Manual General de Usuario - 2020.pdf"
            :page="2"
          ></pdf>
        </div>
        <div class="col-md-6 text-center">
          <div class="row">
            <div class="col-6 mx-auto">
              <pdf
                src="/BeeReaders - Manual General de Usuario - 2020.pdf"
              ></pdf>
              <!-- <pdf src="/BeeReaders - Manual General de Usuario - 2020.pdf"></pdf> -->
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12 text-logo h3 text-center">
              Manual de Usuario
            </div>
          </div>
          <div class="row">
            <div class="col-md-8 subtitle text-center mx-auto">
              <!-- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce vel
              lobortis nisl. In id cursus neque, sed luctus leo. -->
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 text-center">
              <button class="button primary" @click="showNotification">
                <a
                  class="text-white download"
                  href="/BeeReaders - Manual General de Usuario - 2020.pdf"
                  download
                >
                  Descargar
                </a>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <button class="button secondary" @click="$emit('close')">
                Dejar de ver
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";
import pdf from "vue-pdf";

export default {
  name: "ModalPreview",
  components: {
    Modal,
    pdf,
  },
  methods: {
    showNotification() {
      this.$notify({
        title: ["PDF Descargado"],
        type: "success",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.download:hover {
  text-decoration: none;
}
</style>
